import React, { useMemo } from 'react';
import { Table, Form } from 'react-bootstrap';

const fmtData = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('pt-BR');
};

const chaveContrato = (c) => `${c.codigo_grupo_empresa}-${c.codigo_boleto}`;

const ContratosGrid = ({ contratos, selecionados, onToggle, onToggleAll, pesquisado }) => {
  const todasMarcadas = useMemo(() => {
    if (!contratos || contratos.length === 0) return false;
    return contratos.every((c) => selecionados.has(chaveContrato(c)));
  }, [contratos, selecionados]);

  if (!pesquisado) {
    return (
      <div className="text-center text-muted py-4">
        Use os filtros acima e clique em <strong>Pesquisar</strong> para listar contratos
        elegíveis.
      </div>
    );
  }

  if (!contratos || contratos.length === 0) {
    return (
      <div className="text-center text-muted py-4">
        Nenhum contrato elegível encontrado para os filtros informados.
      </div>
    );
  }

  return (
    <div style={{ overflowX: 'auto' }}>
      <Table striped hover size="sm" className="mb-0" style={{ fontSize: '0.85rem' }}>
        <thead style={{ backgroundColor: '#f1f4f9' }}>
          <tr>
            <th style={{ width: '40px' }}>
              <Form.Check
                type="checkbox"
                id="toggle-todos"
                checked={todasMarcadas}
                onChange={onToggleAll}
                aria-label="Selecionar todos"
              />
            </th>
            <th>Família / Empreendimento</th>
            <th>Imóvel</th>
            <th>Boleto</th>
            <th>Cliente</th>
            <th>Forma de quitação</th>
            <th>Data quitação</th>
            <th>Escritura</th>
            <th>Declaração (R)</th>
            <th>Comunicado (C)</th>
          </tr>
        </thead>
        <tbody>
          {contratos.map((c) => {
            const chave = chaveContrato(c);
            const marcada = selecionados.has(chave);
            return (
              <tr key={chave} className={marcada ? 'table-active' : ''}>
                <td>
                  <Form.Check
                    type="checkbox"
                    id={`sel-${chave}`}
                    checked={marcada}
                    onChange={() => onToggle(c)}
                    aria-label={`Selecionar boleto ${c.codigo_boleto}`}
                  />
                </td>
                <td>{c.nome_da_familia}</td>
                <td>
                  <span className="text-muted mr-1">{c.codigo_ativo}</span>
                  {c.nome_imovel}
                </td>
                <td>{c.codigo_boleto}</td>
                <td>{c.nome_cliente}</td>
                <td>{c.forma_quitacao}</td>
                <td>{fmtData(c.dt_quita)}</td>
                <td>
                  {c.escriturado ? (
                    <span className="badge badge-success">Sim</span>
                  ) : (
                    <span className="badge badge-secondary">Não</span>
                  )}
                </td>
                <td>
                  {c.declaracao_emitida ? (
                    <span title={c.nome_usu_imp_declaracao || ''}>
                      <span className="badge badge-info">Sim</span>
                      <small className="text-muted ml-1">{fmtData(c.data_imp_declaracao)}</small>
                    </span>
                  ) : (
                    <span className="badge badge-light">Não</span>
                  )}
                </td>
                <td>
                  {c.comunicado_emitido ? (
                    <span title={c.nome_usu_imp_comunicado || ''}>
                      <span className="badge badge-info">Sim</span>
                      <small className="text-muted ml-1">{fmtData(c.data_imp_comunicado)}</small>
                    </span>
                  ) : (
                    <span className="badge badge-light">Não</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default ContratosGrid;
export { chaveContrato };
